/*
 * src/router/index.ts
 */
import { route } from 'quasar/wrappers';
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
//
//import routes from './routes';
import vrteSystem from 'src/router/vrteSystem';
import vrtNotFound from 'src/router/vrtNotFound';
//
// import vrteSystemBlank from 'src/pages/vrteSystemBlank';
//
import vrtAuth from 'src/auth/vrtAuth';
import vrtUser from 'src/user/vrtUser';
import vrteSystemSetting from 'src/eSystemSetting/vrteSystemSetting';
//
import vrt136 from 'src/eServices/136/vrt136';
import vrtAttendance from 'src/eServices/attendance/vrtAttendance';
import vrtClaim from 'src/eServices/claim/vrtClaim';
import vrtContactAdmin from 'src/eServices/contactus/vrtContact';
import vrteLCVentory from 'src/eServices/eLCVentory/vrteLCVentory';
import vrtPublic from 'src/public/vrtPublic';
import vrtHAF from 'src/eServices/HAF/vrtHAF';
import vrtLeave from 'src/eServices/leave/vrtLeave';
import vrtNameCard from 'src/eServices/nameCard/vrtNameCard';
import vrtOTClaim from 'src/eServices/OTclaim/vrtOTClaim';
import vrtParticular from 'src/eServices/particular/vrtParticular';
import vrtQAF from 'src/eServices/QAF/vrtQAF';
import vrtTask from 'src/eServices/task/vrtTask';
//
import vrtMTIVentory from 'src/POWERsup/vrtMTIVentory';
//
import vrtPSHTF from 'src/POWERsteer/POWERsteerHTF/vrtPSHTF';
import vrtPSTMO from 'src/POWERsteer/POWERsteerTMO/vrtPSTMO';
import vrtPSTrainer from 'src/POWERsteer/POWERsteerTrainer/vrtPSTrainer';
import vrtPSTrainee from 'src/POWERsteer/POWERsteerTrainee/vrtPSTrainee';
import vrtPSWorkshop from 'src/POWERsteer/POWERsteerWorkshop/vrtPSWorkshop';
import vrtPSTester from 'src/POWERsteer/POWERsteerTester/vrtPSTester';
import vrtPSSTS from 'src/POWERsteer/POWERsteerSTS/vrtPSSTS';
import vrtPSSetting from 'src/POWERsteer/POWERsteerSetting/vrtPSSetting';
import vrtPSDTSS from 'src/POWERsteer/POWERsteerDTSS/vrtPSDTSS';
// WARN: 20241129 - Codekeeping, merge into one of the module above!!!
import vrtPSVLogbook from 'src/POWERsteer/POWERsteerVLogbook/vrtPSVLogbook';
import vrtLuckyDraw from 'src/eServices/luckyDraw/vrtLuckyDraw';
import vrtPSHTFV2 from 'src/POWERsteer/POWERsteerHTFV2/vrtPSHTFV2';
//
// If not building with SSR mode, you can directly export the Router instantiation;
// The function below can be async too; either use async/await or return a Promise
// which resolves with the Router instance.
//
let moVueRouter = null;
//
export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    //
    routes: [
      vrteSystem,
      //
      vrtAuth,
      vrtUser,
      vrteSystemSetting,
      //
      // PUBLIC (No Authentication)
      //
      vrtPublic,
      //
      // eSERVICES
      //
      vrt136,
      vrtAttendance,
      vrtClaim,
      vrtContactAdmin, // Admin contact list - authentication required
      vrteLCVentory,
      vrtHAF,
      vrtLeave,
      vrtNameCard,
      vrtOTClaim,
      vrtParticular,
      vrtQAF,
      vrtTask,
      vrtLuckyDraw,
      //
      // ePOWERsup (MTI)
      //
      vrtMTIVentory,
      //
      // ePOWERsteer (Project B)
      //
      vrtPSHTF,
      vrtPSHTFV2,
      vrtPSTMO,
      vrtPSTrainer,
      vrtPSTrainee,
      vrtPSWorkshop,
      vrtPSTester,
      vrtPSSTS,
      vrtPSSetting,
      vrtPSDTSS,
      //
      vrtPSVLogbook,
      //
      // Must be the LAST item!!!
      //
      vrtNotFound,
    ],
    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });
  //
  moVueRouter = Router;
  return Router;
});
//
export { moVueRouter };
//#end#
